import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b53f5924"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card g-xxl-9 mb-8"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Активна заявка", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-muted fw-bold fs-7"
}
const _hoisted_6 = {
  key: 1,
  class: "text-muted fw-bold fs-7"
}
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table table-row-dashed align-middle gs-0 gy-4 my-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fs-7 fw-bolder text-gray-500 border-bottom-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-85px w-xxl-85px" }, "№ заявки"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }, "Заявка"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }, "Мастер"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-100px" }, "Дата"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-100px" }, "Дії")
  ])
], -1))
const _hoisted_14 = { class: "text-gray-800 fw-bolder d-block mb-1 fs-6" }
const _hoisted_15 = { class: "text-dark fw-bolder d-block mb-1 fs-6" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "symbol symbol-30px symbol-lg-30px symbol-fixed position-relative" }
const _hoisted_18 = {
  key: 0,
  src: "media/avatars/blank.png",
  alt: "image",
  class: ""
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_23 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_24 = { class: "text-dark fw-bolder d-block mb-1 fs-6" }
const _hoisted_25 = { class: "text-muted fw-bold text-muted d-block fs-7 mt-1" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["disabled", "data-kt-indicator"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-stop" }),
  /*#__PURE__*/_createTextVNode("Скасувати")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Будь ласка, чекайте ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  colspan: "4",
  class: ""
}
const _hoisted_32 = { class: "d-flex align-self-center" }
const _hoisted_33 = { class: "flex-grow-1 me-3" }
const _hoisted_34 = { class: "fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = ["disabled", "data-kt-indicator"]
const _hoisted_38 = { class: "svg-icon svg-icon-1" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Будь ласка, чекайте ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_40 = {
  key: 1,
  class: ""
}
const _hoisted_41 = { class: "svg-icon svg-icon-success me-5" }
const _hoisted_42 = {
  key: 0,
  src: "media/smiles/happy.png"
}
const _hoisted_43 = {
  key: 1,
  src: "media/smiles/sad.png"
}
const _hoisted_44 = {
  key: 2,
  src: "media/smiles/shocked.png"
}
const _hoisted_45 = { class: "flex-grow-1 me-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-6" }, "Ваш відгук", -1))
const _hoisted_47 = { class: "text-muted fw-bold d-block" }
const _hoisted_48 = {
  colspan: "1",
  class: "text-end"
}
const _hoisted_49 = {
  key: 0,
  class: "rating float-end me-4"
}
const _hoisted_50 = {
  key: 1,
  class: "row g-xxl-9"
}
const _hoisted_51 = { class: "col-xxl-7" }
const _hoisted_52 = { class: "card card-xxl-stretch mb-5 mb-xxl-10" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Статистика заявок")
  ])
], -1))
const _hoisted_54 = { class: "card-body pb-0 pt-0" }
const _hoisted_55 = { class: "fs-5 fw-bold text-gray-600 pb-5 d-block" }
const _hoisted_56 = { class: "row g-xxl-12" }
const _hoisted_57 = { class: "col col-xxl-6 col-md-6 col-sm-6 col-6" }
const _hoisted_58 = { class: "border border-dashed border-gray-300 rounded my-3 p-4 me-6" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "progress h-6px w-100 me-2 bg-light-primary" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "progress-bar bg-primary",
      role: "progressbar",
      style: {"width":"100%"},
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold" }, "100%")
], -1))
const _hoisted_60 = { class: "fs-2x fw-bolder text-gray-800 lh-1" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400 d-block lh-1 pt-2" }, "всього заявок", -1))
const _hoisted_62 = { class: "col col-xxl-6 col-md-6 col-sm-6 col-6" }
const _hoisted_63 = { class: "border border-dashed border-gray-300 rounded my-3 p-4 me-6" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = { class: "progress h-6px w-100 me-2 bg-light-success" }
const _hoisted_66 = ["aria-valuenow"]
const _hoisted_67 = { class: "text-gray-400 fw-bold" }
const _hoisted_68 = { class: "fs-2x fw-bolder text-gray-800 lh-1" }
const _hoisted_69 = { class: "" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400 d-block lh-1 pt-2" }, "виконаних", -1))
const _hoisted_71 = { class: "col col-xxl-6 col-md-6 col-sm-6 col-6" }
const _hoisted_72 = { class: "border border-dashed border-gray-300 rounded my-3 p-4 me-6" }
const _hoisted_73 = { class: "d-flex align-items-center" }
const _hoisted_74 = { class: "progress h-6px w-100 me-2 bg-light-danger" }
const _hoisted_75 = ["aria-valuenow"]
const _hoisted_76 = { class: "text-gray-400 fw-bold" }
const _hoisted_77 = { class: "fs-2x fw-bolder text-gray-800 lh-1" }
const _hoisted_78 = { class: "" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400 d-block lh-1 pt-2" }, "активних", -1))
const _hoisted_80 = { class: "col col-xxl-6 col-md-6 col-sm-6 col-6" }
const _hoisted_81 = { class: "border border-dashed border-gray-300 rounded my-3 p-4 me-6" }
const _hoisted_82 = { class: "d-flex align-items-center" }
const _hoisted_83 = { class: "progress h-6px w-100 me-2 bg-light-warning" }
const _hoisted_84 = ["aria-valuenow"]
const _hoisted_85 = { class: "text-gray-400 fw-bold" }
const _hoisted_86 = { class: "fs-2x fw-bolder text-gray-800 lh-1" }
const _hoisted_87 = { class: "" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400 d-block lh-1 pt-2" }, "скасованих", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap justify-content-between pb-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap" })
], -1))
const _hoisted_90 = { class: "col-xxl-5" }
const _hoisted_91 = { class: "card card-xxl-stretch mb-5 mb-xxl-10" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-gray-800" }, "Нова заявка")
  ])
], -1))
const _hoisted_93 = { class: "card-body pt-0" }
const _hoisted_94 = { class: "fs-5 fw-bold text-gray-600 pb-6 d-block" }
const _hoisted_95 = { class: "d-flex align-self-center" }
const _hoisted_96 = { class: "flex-grow-1 me-3" }
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "fv-plugins-message-container" }
const _hoisted_99 = { class: "fv-help-block" }
const _hoisted_100 = { class: "d-flex align-self-center" }
const _hoisted_101 = { class: "flex-grow-1 me-3" }
const _hoisted_102 = { class: "fv-row mb-10" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Короткий опис (не обов'язково)", -1))
const _hoisted_104 = ["disabled", "data-kt-indicator"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }),
  /*#__PURE__*/_createTextVNode("Відправити")
], -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Будь ласка, чекайте ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = {
  key: 2,
  class: "card"
}
const _hoisted_109 = { class: "card-header pt-3 mb-5" }
const _hoisted_110 = { class: "card-title align-items-start flex-column" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Список заявок", -1))
const _hoisted_112 = { class: "text-muted fw-bold fs-7" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("a", {
    id: "kt_phones_help_toggle",
    class: "btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 shadow-sm fs-6 px-4 rounded-top-0"
  }, "Тех. підтримка")
], -1))
const _hoisted_114 = { class: "card-body" }
const _hoisted_115 = { class: "table-responsive" }
const _hoisted_116 = { class: "table table-flush table-striped align-middle table-row-bordered table-row-solid gy-4 gs-9" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "border-gray-200 fs-5 fw-bold bg-lighten" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px ps-9" }, "№"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Тип заявки"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px px-0" }, "Дата"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Мастер"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px text-center" }, "Статус")
  ])
], -1))
const _hoisted_118 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_119 = { class: "ps-9" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_121 = { class: "pe-5" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_123 = { class: "ps-0" }
const _hoisted_124 = { class: "" }
const _hoisted_125 = { class: "symbol symbol-30px symbol-lg-30px symbol-fixed position-relative" }
const _hoisted_126 = {
  key: 0,
  src: "media/avatars/blank.png",
  alt: "image",
  class: ""
}
const _hoisted_127 = ["src"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_129 = ["href"]
const _hoisted_130 = { class: "text-center" }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { key: 1 }
const _hoisted_133 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_MyRate = _resolveComponent("MyRate")!
  const _component_ExclamationNotice = _resolveComponent("ExclamationNotice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.userData && _ctx.requestsData && _ctx.requestsData.active_request)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.requestsData.active_request.status == 'active')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "заявка у процесі виконання"))
                : (_ctx.requestsData.active_request.status == 'completed')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "заявку виконано"))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.requestsData.active_request.status == 'active')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Виконується"))
                : (_ctx.requestsData.active_request.status == 'completed')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Виконано"))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.requestsData.active_request.id), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.requestsData.active_request.header), 1),
                      (_ctx.requestsData.active_request.client_note != '')
                        ? (_openBlock(), _createElementBlock("small", _hoisted_16, "примітка: " + _toDisplayString(_ctx.requestsData.active_request.client_note), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.requestsData.active_request.avatar == '')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                          : (_ctx.requestsData.active_request.avatar != '')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.requestsData.active_request.avatar,
                                alt: "image",
                                class: ""
                              }, null, 8, _hoisted_19))
                            : _createCommentVNode("", true)
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.requestsData.active_request.first_name) + " ", 1),
                      _hoisted_20,
                      (_ctx.requestsData.active_request.work_phone != '')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: 'tel:' + _ctx.requestsData.active_request.work_phone
                          }, [
                            _createElementVNode("small", null, "т. " + _toDisplayString(_ctx.requestsData.active_request.work_phone), 1)
                          ], 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("a", _hoisted_23, _toDisplayString(), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.requestsData.active_request.inProgressFromDate), 1),
                      _createElementVNode("span", _hoisted_25, "минулий час: " + _toDisplayString(_ctx.requestsData.active_request.elapsed_time_label), 1)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      (
                    _ctx.requestsData.active_request.client_login ==
                      _ctx.userData.user.login &&
                    _ctx.requestsData.active_request.status != 'completed'
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "submit",
                            class: "btn btn-warning px-6 flex-shrink-0 align-npmself-center",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCancelRequest())),
                            disabled: _ctx.in_progress,
                            "data-kt-indicator": _ctx.in_progress ? 'on' : 'off'
                          }, _hoisted_30, 8, _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_31, [
                      (
                                    _ctx.requestsData.active_request.status == 'completed' &&
                                    _ctx.requestsData.active_request.client_work_note == ''
                                  )
                        ? (_openBlock(), _createBlock(_component_Form, {
                            key: 0,
                            class: "form w-100",
                            id: "kt_note_request_form",
                            "validation-schema": _ctx.new_note_to_request,
                            onSubmit: _ctx.addNewNoteToRequest
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_Field, {
                                      class: "form-control form-control-lg form-control-solid",
                                      type: "text",
                                      name: "short_note",
                                      placeholder: "Короткий відгук про якість виконаної роботи",
                                      autocomplete: "off"
                                    }),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createVNode(_component_ErrorMessage, { name: "short_note" })
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "submit",
                                  class: "btn btn-primary btn-icon flex-shrink-0",
                                  disabled: _ctx.in_progress,
                                  "data-kt-indicator": _ctx.in_progress ? 'on' : 'off'
                                }, [
                                  _createElementVNode("span", _hoisted_38, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
                                  ]),
                                  _hoisted_39
                                ], 8, _hoisted_37)
                              ])
                            ]),
                            _: 1
                          }, 8, ["validation-schema", "onSubmit"]))
                        : (_ctx.requestsData.active_request.client_work_note != '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["d-flex align-items-center rounded p-5 mb-1", {
                      'bg-light-success':
                        _ctx.requestsData.active_request.client_work_rating >= 4,
                      'bg-light-warning':
                        _ctx.requestsData.active_request.client_work_rating < 4 &&
                        _ctx.requestsData.active_request.client_work_rating > 2,
                      'bg-light-danger':
                        _ctx.requestsData.active_request.client_work_rating <= 2,
                    }])
                              }, [
                                _createElementVNode("span", _hoisted_41, [
                                  (
                          _ctx.requestsData.active_request.client_work_rating > 4
                        )
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                                    : (
                          _ctx.requestsData.active_request.client_work_rating < 4 &&
                          _ctx.requestsData.active_request.client_work_rating > 2
                        )
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                                      : (
                          _ctx.requestsData.active_request.client_work_rating <= 2
                        )
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.requestsData.active_request.client_work_note), 1)
                                ])
                              ], 2)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_48, [
                      (_ctx.requestsData.active_request.status == 'completed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createVNode(_component_MyRate, {
                              rating: _ctx.requestsData.active_request.client_work_rating,
                              "star-size": 32,
                              animate: 
                      _ctx.requestsData.active_request.client_work_rating == 0
                    ,
                              "read-only": 
                      _ctx.requestsData.active_request.client_work_rating > 0
                    ,
                              onOnRate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRateWork($event)))
                            }, null, 8, ["rating", "animate", "read-only"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (_ctx.requestsData.active_request.status == 'active')
                ? (_openBlock(), _createBlock(_component_ExclamationNotice, {
                    key: 0,
                    icon: "media/icons/duotune/general/gen046.svg",
                    "icon-class": "svg-icon-success",
                    header: "Увага. Выполнение заявки!",
                    bg: "bg-light-success",
                    border: "border-light-success",
                    msg: "Після виконання заявки у Вас є можливість оцінити якість обслуговування, залишивши відгук та поставивши оцінку. Ваш відгук допоможе нам покращити якість обслуговування."
                  }))
                : _createCommentVNode("", true),
              (_ctx.requestsData.active_request.status == 'active')
                ? (_openBlock(), _createBlock(_component_ExclamationNotice, {
                    key: 1,
                    icon: "media/icons/duotune/general/gen044.svg",
                    "icon-class": "svg-icon-primary",
                    header: "Увага!",
                    bg: "bg-light-primary",
                    border: "border-light-primary",
                    msg: "Мінімальний час виконання заявки 24 години. Додана заявка надсилається майстру протягом 5 секунд. "
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData && _ctx.requestsData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, [
                  _createVNode(_component_ExclamationNotice, {
                    header: "Дані за заявками",
                    msg: "У даному розділі, у Вас є можливість переглянути загальну статистику за заявками, список усіх заявок, а також, якщо у Вас виникли проблеми з доступом до інтернету, залишити заявку."
                  })
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("span", _hoisted_60, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.requestsData.statistic.total), 1)
                      ]),
                      _hoisted_61
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", {
                            class: "progress-bar bg-success",
                            role: "progressbar",
                            style: _normalizeStyle(
                        'width:' + _ctx.requestsData.statistic.completed_p + '%'
                      ),
                            "aria-valuenow": _ctx.requestsData.statistic.completed_p,
                            "aria-valuemin": "0",
                            "aria-valuemax": "100"
                          }, null, 12, _hoisted_66)
                        ]),
                        _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.requestsData.statistic.completed_p) + "%", 1)
                      ]),
                      _createElementVNode("span", _hoisted_68, [
                        _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.requestsData.statistic.completed), 1)
                      ]),
                      _hoisted_70
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", {
                            class: "progress-bar bg-danger",
                            role: "progressbar",
                            style: _normalizeStyle('width:' + _ctx.requestsData.statistic.active_p + '%'),
                            "aria-valuenow": _ctx.requestsData.statistic.active_p,
                            "aria-valuemin": "0",
                            "aria-valuemax": "100"
                          }, null, 12, _hoisted_75)
                        ]),
                        _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.requestsData.statistic.active_p) + "%", 1)
                      ]),
                      _createElementVNode("span", _hoisted_77, [
                        _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.requestsData.statistic.active), 1)
                      ]),
                      _hoisted_79
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", {
                            class: "progress-bar bg-warning",
                            role: "progressbar",
                            style: _normalizeStyle(
                        'width:' + _ctx.requestsData.statistic.cancelled_p + '%'
                      ),
                            "aria-valuenow": _ctx.requestsData.statistic.cancelled_p,
                            "aria-valuemin": "0",
                            "aria-valuemax": "100"
                          }, null, 12, _hoisted_84)
                        ]),
                        _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.requestsData.statistic.cancelled_p) + "%", 1)
                      ]),
                      _createElementVNode("span", _hoisted_86, [
                        _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.requestsData.statistic.cancelled), 1)
                      ]),
                      _hoisted_88
                    ])
                  ])
                ]),
                _hoisted_89
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createVNode(_component_Form, {
                  class: "form w-100",
                  id: "kt_no_money_request_form",
                  "validation-schema": _ctx.new_request,
                  onSubmit: _ctx.addNewRequest
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_94, [
                      _createVNode(_component_ExclamationNotice, {
                        icon: "media/icons/duotune/general/gen046.svg",
                        "icon-class": "svg-icon-primary",
                        bg: "bg-light-primary",
                        border: "border-light-primary",
                        header: "Додавання заявки",
                        msg: "При виникненні проблем з доступом в інтернет,\n                                        а Вас є можливість залишити заявку,\n                                        яка буде передана майстру."
                      })
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createVNode(_component_Field, {
                          class: "form-control form-control-lg form-control-solid form-select form-select-solid",
                          as: "select",
                          name: "req_type"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestsData.request_types, (type) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: type.id,
                                key: type.id
                              }, _toDisplayString(type.header), 9, _hoisted_97))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createVNode(_component_ErrorMessage, { name: "req_type" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _hoisted_103,
                          _createVNode(_component_Field, {
                            class: "form-control form-control-lg form-control-solid",
                            type: "text",
                            name: "req_short_description",
                            autocomplete: "off"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-success px-6 flex-shrink-0 align-self-center float-end",
                      disabled: _ctx.in_progress,
                      "data-kt-indicator": _ctx.in_progress ? 'on' : 'off'
                    }, _hoisted_107, 8, _hoisted_104)
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onSubmit"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData && _ctx.requestsData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _hoisted_111,
              _createElementVNode("span", _hoisted_112, "всього заявок: " + _toDisplayString(_ctx.requestsData.requests_list.length), 1)
            ]),
            _hoisted_113
          ]),
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("table", _hoisted_116, [
                _hoisted_117,
                _createElementVNode("tbody", _hoisted_118, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestsData.requests_list, (request) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: request.id
                    }, [
                      _createElementVNode("td", _hoisted_119, [
                        _createTextVNode(_toDisplayString(request.id) + " ", 1),
                        _hoisted_120,
                        _createVNode(_component_MyRate, {
                          rating: request.client_work_rating,
                          "star-size": 16,
                          onOnRate: ($event: any) => (request.client_work_rating = $event),
                          readOnly: true,
                          animate: false
                        }, null, 8, ["rating", "onOnRate"])
                      ]),
                      _createElementVNode("td", _hoisted_121, [
                        _createTextVNode(_toDisplayString(request.req_header) + " ", 1),
                        _hoisted_122,
                        _createElementVNode("small", null, "т. " + _toDisplayString(request.phone), 1)
                      ]),
                      _createElementVNode("td", _hoisted_123, _toDisplayString(request.date), 1),
                      _createElementVNode("td", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          (request.avatar == '')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_126))
                            : (request.avatar != '')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: request.avatar,
                                  alt: "image",
                                  class: ""
                                }, null, 8, _hoisted_127))
                              : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(" " + _toDisplayString(request.first_name) + " ", 1),
                        _hoisted_128,
                        (request.work_phone != '')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: 'tel:' + request.work_phone
                            }, [
                              _createElementVNode("small", null, "т. " + _toDisplayString(request.work_phone), 1)
                            ], 8, _hoisted_129))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_130, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", {
                    'badge-success': request.status == 'completed',
                    'badge-primary': request.status == 'active',
                    'badge-warning': request.status == 'cancelled',
                  }])
                        }, [
                          (request.status == 'completed')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_131, "Виконано"))
                            : (request.status == 'active')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_132, "Активна"))
                              : (request.status == 'cancelled')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_133, "Скасовано"))
                                : _createCommentVNode("", true)
                        ], 2)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}